import { render, staticRenderFns } from "./importRecordDetail.vue?vue&type=template&id=0700c628&scoped=true&"
import script from "./importRecordDetail.vue?vue&type=script&lang=js&"
export * from "./importRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./importRecordDetail.vue?vue&type=style&index=0&id=0700c628&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0700c628",
  null
  
)

export default component.exports